import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { STATIC_ROOT } from '../../../../../constants';
import { MODAL_TYPE_KYC } from '../../../../../services/modal/constants';

import { showModal } from '../../../../../services/modal/actions';

import { convertHtmlToReactDomWithParams } from '../../../../../utils/htmlUtils';

import ButtonComponent from '../../../../button/ButtonComponent';

import './ErrorEbonPageKycBlocStyle.scss';

const ErrorEbonPageKycBloc = ({ show, kycErrorCase, i18n, showModal }) => {
    if (!show) {
        return null;
    }

    const showKycModal = () => {
        showModal(MODAL_TYPE_KYC, {
            hideCloseButton: true,
            useCase: kycErrorCase
        });
    };

    return (
        <div className="conteneur-color kyc">
            <p>{convertHtmlToReactDomWithParams(i18n.TEXT_KYC_1)}</p>
            <ButtonComponent
                color="main"
                text={i18n.TEXT_KYC_BUTTON_TEXT}
                onClick={showKycModal}
            />

            <p className="info">{convertHtmlToReactDomWithParams(i18n.TEXT_KYC_2)}</p>
            <div className="ubble">
                <div>{i18n.TEXT_KYC_3}</div>
                <div>
                    <img
                        src={`${STATIC_ROOT}/kyc/ubble.png`}
                        alt={i18n.UBBLE_ALT}
                        width="100"
                        height="37"
                    />
                </div>
            </div>
        </div>
    );
};

ErrorEbonPageKycBloc.propTypes = {
    show: PropTypes.bool,
    kycErrorCase: PropTypes.string
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.EBON.ERROR
    };
};

const mapDispatchToProps = {
    showModal
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorEbonPageKycBloc);



// WEBPACK FOOTER //
// ./src/components/pages/ebon/erreur/kyc/ErrorEbonPageKycBloc.js